import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import App from './App.vue';
import mitt from "mitt";
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import utils from './libs/utils/comm.js';
import audio from 'vue-mobile-audio';
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueViewer);
Vue.use(ViewUI);
Vue.use(ElementUI);
Vue.prototype.$bus = new mitt();
Vue.prototype.utils = utils;

//导入自定义css
import './assets/css/common.css'

//引入font-awesome字体图标
import 'font-awesome/scss/font-awesome.scss'

//处理websokcet
import { WebSocket } from "@/libs/socket/WebSocket";
import Setting from "@/setting";
Vue.prototype.socket = new WebSocket({
    wsUrl : Setting.wsUrl,
    key : Setting .wsKey
});

const store = require('./store/index').default;
const router = require('./router/index').default;
store.dispatch('pub/page/init',{});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
